export const interests = [
  'Software Development',
  'Algorithms',
  'Algorithmic Thinking',
  'Full Stack Development',
  'Web Development',
  'Machine Learning',
  'Robotics',
];

export const otherInterests = [
  'Astronomy',
  'Physics',
  'Math',
  'Neurology',
  'Psychology',
  'Human Behaviour',
  'Leadership',
  'Entrepreneurship',
];

export const education = [
  {
    logo: 'assets/Images/Education/logo_langara.webp',
    title: 'Langara College',
    degree: 'Associate\'s Degree',
    program: 'Computer Science',
    duration: 'Sep 2017 - Aug 2019',
  },
  {
    logo: 'assets/Images/Education/logo_ubc.webp',
    title: 'University of British Columbia',
    degree: 'Bachelor\'s Degree',
    program: 'Computer Science',
    duration: 'Sep 2019 - Present',
  },
];

export const experience = [
  {
    logo: 'assets/Images/Experience/logo_porton.webp',
    company: 'Porton Health Corp',
    title: 'Full Stack Engineer',
    duration: 'May 2019 - Present',
  },
];
